import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useHydratedAccess } from "../../lib/hooks/useHydratedAccess";
import { useLoginStore } from "../../store/useLoginStore";

export default function ProtectRoute() {
    const hydrated = useHydratedAccess();
    const isAuthed = useLoginStore((s) => s.isAuthenticated());
    const willExpireSoon = useLoginStore((s) => s.willExpireSoon());
    const loc = useLocation();

    if (!hydrated) return null;

    if (!isAuthed || willExpireSoon) {
        return <Navigate to="/login" replace state={{ from: loc }} />;
    }

    return <Outlet />
}